<div class="space-y-4 p-4">
  <!-- Parent Insider Comment Section -->
  <div class="space-y-2" *ngIf="hasParent">
    <label class="block text-sm font-medium text-gray-700">
      Parent Insider Comment
      <span *ngIf="parentName" class="text-xs font-normal text-gray-500">({{ parentName }})</span>
    </label>
    <textarea
      [(ngModel)]="parentComment"
      rows="3"
      class="w-full rounded-md border border-gray-300 p-3 text-sm focus:border-gray-400 focus:outline-none resize-none"
      placeholder="Enter parent comment"
    ></textarea>
  </div>

  <!-- Child Insider Comment Section -->
  <div class="space-y-2" *ngIf="hasChild">
    <label class="block text-sm font-medium text-gray-700">
      Child Insider Comment
      <span *ngIf="childName" class="text-xs font-normal text-gray-500">({{ childName }})</span>
    </label>
    <textarea
      [(ngModel)]="childComment"
      rows="3"
      class="w-full rounded-md border border-gray-300 p-3 text-sm focus:border-gray-400 focus:outline-none resize-none"
      placeholder="Enter child comment"
    ></textarea>
  </div>

  <div class="flex justify-end gap-3 pt-4">
    <button
      type="button"
      class="py-2 px-5 border border-[#d9d9d9] rounded bg-white text-gray-800 cursor-pointer hover:bg-gray-50"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="py-2 px-5 border border-[#d9d9d9] rounded bg-[#1f273b] text-white cursor-pointer hover:bg-[#2a334a]"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
